import { cn } from "@/lib/utils";

export function IndexSkeletonLoader({ isDarkMode }: { isDarkMode: boolean }) {
  // Colors based on the screenshot:
  // Dark mode skeleton matches the lighter grey of the input box/text
  const skeletonColor = isDarkMode ? "bg-[#424242]" : "bg-gray-200";
  const inputBaseColor = isDarkMode ? "bg-[#2f2f2f]" : "bg-gray-100";

  return (
    <div className="flex flex-col h-full w-full min-h-screen relative overflow-hidden">

      {/* 2. Main Centered Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 -mt-20">
        
        {/* "What can I do for you?" Title Skeleton */}
        <div className={cn(
          "w-64 h-8 rounded-lg animate-pulse mb-8",
          skeletonColor
        )} />

        {/* Input Area Box Skeleton */}
        <div className={cn(
          "w-full max-w-3xl rounded-[26px] p-4 animate-pulse dark:border dark:border-1 dark:border-[#1c1c1c] relative",
          "h-36", // Height to match the large textarea look
          inputBaseColor 
        )}>
          {/* Internal Input Placeholder Text */}
          <div className={cn(
            "w-1/3 h-5 rounded-md opacity-50",
            isDarkMode ? "bg-gray-500" : "bg-gray-300"
          )} />

          {/* Bottom Icons Row */}
          <div className="absolute bottom-3 left-4 right-4 flex justify-between items-center">
            
            {/* Left Actions (Plus & Agents) */}
            <div className="flex gap-3">
              <div className={cn(
                "w-8 h-8 rounded-full",
                isDarkMode ? "bg-gray-600" : "bg-gray-300"
              )} />
              <div className={cn(
                "w-20 h-8 rounded-full",
                isDarkMode ? "bg-gray-600" : "bg-gray-300"
              )} />
            </div>

            {/* Right Action (Microphone) */}
            <div className={cn(
              "w-8 h-8 rounded-full",
              isDarkMode ? "bg-gray-600" : "bg-gray-300"
            )} />
          </div>
        </div>
      </div>
      
      {/* Footer Text Skeleton */}
      <div className="absolute bottom-4 left-0 right-0 flex justify-center">
         <div className={cn(
            "w-48 h-3 rounded-md animate-pulse opacity-50",
            skeletonColor
          )} />
      </div>
    </div>
  );
}